import React from "react";
import { createPortal } from "react-dom";
import { ModalDiv } from "./GlobalSmallPopup.styles";
import { OutsideClickHandler } from "./OutsideClickHandler";

const GlobalSmallPopup = ({
    children,
    onRequestClose,
}: {
    children: React.ReactNode;
    onRequestClose: () => void;
}) => {
    // The portal target. The admin HTML only ships a #root div, so #modal-root
    // may not exist — creating it on demand (rather than asserting it with `!`)
    // is what stops logout from crashing with "Cannot read properties of null
    // (reading 'appendChild')".
    const elRef = React.useRef<HTMLDivElement | null>(null);
    if (elRef.current === null) {
        elRef.current = document.createElement("div");
    }

    React.useEffect(() => {
        let modalRoot = document.getElementById("modal-root");
        if (!modalRoot) {
            modalRoot = document.createElement("div");
            modalRoot.setAttribute("id", "modal-root");
            document.body.appendChild(modalRoot);
        }
        const el = elRef.current!;
        modalRoot.appendChild(el);
        return () => {
            modalRoot!.removeChild(el);
        };
    }, []);

    return createPortal(
        <ModalDiv>
            <div className="overlay">
                <OutsideClickHandler
                    onOutsideClick={() => {
                        onRequestClose();
                    }}
                >
                    <div className="content">{children}</div>
                </OutsideClickHandler>
            </div>
        </ModalDiv>,
        elRef.current,
    );
};

export default GlobalSmallPopup;
